import { LtvDraft, VehicleEntrySnapshot } from '../graybook/ltvDraft'
import {
  FirestoreDataConverter,
  DocumentSnapshot,
  SnapshotOptions,
  WithFieldValue,
} from 'firebase/firestore'

const normalizeEntry = (raw: any): VehicleEntrySnapshot => ({
  id: raw?.id || '',
  inputMode: raw?.inputMode === 'manual' ? 'manual' : 'inventory',
  vehicleId: raw?.vehicleId ?? null,
  formulaId: raw?.formulaId ?? null,
  description: raw?.description || '',
  vin: raw?.vin ?? null,
  makeModel: raw?.makeModel || '',
  grayBookRetailPrice:
    typeof raw?.grayBookRetailPrice === 'number' ? raw.grayBookRetailPrice : null,
  pricingMethod: raw?.pricingMethod || '',
  salesPrice: typeof raw?.salesPrice === 'number' ? raw.salesPrice : 0,
  tradeInAllowance: typeof raw?.tradeInAllowance === 'number' ? raw.tradeInAllowance : (typeof raw?.tradeInValue === 'number' ? raw.tradeInValue : 0),
  tradeInPayoff: typeof raw?.tradeInPayoff === 'number' ? raw.tradeInPayoff : 0,
  vehicleYear: typeof raw?.vehicleYear === 'number' ? raw.vehicleYear : new Date().getFullYear(),
  vehicleMileage: typeof raw?.vehicleMileage === 'number' ? raw.vehicleMileage : 0,
  vehicleColor: raw?.vehicleColor || 'White',
})

export const ltvDraftConverter: FirestoreDataConverter<LtvDraft> = {
  toFirestore(draft: WithFieldValue<LtvDraft>) {
    const { id, ...data } = draft as LtvDraft
    return data
  },
  fromFirestore(snapshot: DocumentSnapshot, options: SnapshotOptions): LtvDraft {
    const data = snapshot.data(options) || {}
    return {
      id: snapshot.id,
      name: data.name || 'Untitled draft',
      description: data.description || '',
      status: data.status === 'finalized' ? 'finalized' : 'draft',
      entries: Array.isArray(data.entries) ? data.entries.map(normalizeEntry) : [],
      ltvInput: data.ltvInput || null,
      calculatorMode: data.calculatorMode === 'target' ? 'target' : 'calculate',
      targetLtvPercent: typeof data.targetLtvPercent === 'number' ? data.targetLtvPercent : 85,
      feeMode: data.feeMode === 'actual' ? 'actual' : 'estimated',
      createdBy: data.createdBy || '',
      createdByEmail: data.createdByEmail || '',
      createdAt: data.createdAt || new Date().toISOString(),
      updatedAt: data.updatedAt || new Date().toISOString(),
      isArchived: !!data.isArchived,
    }
  },
}
